import { render, staticRenderFns } from "./EmulatorEvents.vue?vue&type=template&id=1c87ba40"
import script from "./EmulatorEvents.vue?vue&type=script&lang=js"
export * from "./EmulatorEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c87ba40')) {
      api.createRecord('1c87ba40', component.options)
    } else {
      api.reload('1c87ba40', component.options)
    }
    module.hot.accept("./EmulatorEvents.vue?vue&type=template&id=1c87ba40", function () {
      api.rerender('1c87ba40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Emulator/EmulatorEvents.vue"
export default component.exports